import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useRequests from './useRequests';

const useSingleRequest = () => {
  const { id: routeId } = useParams();
  const { singleItem, loading, titleTypes, statusTexts } = useRequests(
    false,
    false,
  );

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  return {
    singleItem: viewItem,
    loading,
    titleTypes,
    statusTexts,
  };
};

export default useSingleRequest;
